import styles from "./perfil-cover.module.css";
import PerfilModal from "../PerfilModal/perfil-modal";
import coverImg from "../../../images/_finais/perfil-cover_compress.webp";

interface IProps {
  title: string;
  text: string;
  image: any;
  lattes?: string;
  linkedin?: string;
}

const PerfilCover = ({ title, text, image, lattes, linkedin }: IProps) => {
  return (
    <section className={styles.cover_section}>
      <PerfilModal
        title={title}
        text={text}
        image={image}
        lattes={lattes}
        linkedin={linkedin}
      />
      <img
        className={styles.coverImg}
        src={coverImg}
        alt="Cover da página de Perfil."
        loading="lazy"
      />
    </section>
  );
};

export default PerfilCover;
